import {Component, WritableSignal} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {DxPopupModule} from 'devextreme-angular';
import {ChatBoxComponent} from '../chat-box/chat-box.component';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-chat-box-button',
  imports: [
    MatButtonModule,
    MatIconModule,
    DxPopupModule,
    ChatBoxComponent,
    NgIf
  ],
  templateUrl: './chat-box-button.component.html',
  standalone: true,
  styleUrl: './chat-box-button.component.scss'
})
export class ChatBoxButtonComponent {
  popupVisible = false;

  closePopup() {
    this.popupVisible = false;
  }
}
